import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

// Botão fixo para o platform_owner sair do Portal Comercial e voltar ao painel.
export default function VoltarAoPainelOwner() {
  const { user } = useAuth() || {};
  if (user?.role !== "platform_owner") return null;
  return (
    <Link
      to="/app/plataforma-tenants"
      className="fixed bottom-5 right-5 z-50 inline-flex items-center gap-2 h-11 px-4 rounded-xl bg-primary text-primary-foreground text-sm font-semibold shadow-lg hover:bg-primary/90 transition-colors"
    >
      <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
      Painel da plataforma
    </Link>
  );
}
